// Libs
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
// Components, Layouts, Pages
// Others
// Styles, images, icons

type Props = {
  month: string;
};

const HeaderPayrollPdf = (props: Props) => {
  //#region Destructuring Props
  const { month } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <View style={styles.viewText}>
        <Text style={styles.title}>PAYROLL</Text>
      </View>
      <View style={styles.viewText}>
        <Text style={styles.titleDate}>Month:</Text>
        <Text style={styles.date}>{month ? `${month} ${moment().year()}` : moment().year()}</Text>
      </View>
    </View>
  );
};

export default HeaderPayrollPdf;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 5,
  },

  viewText: {
    flexDirection: 'row',
    gap: 5,
  },

  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#2A3962',
  },

  titleDate: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2A3962',
  },

  date: {
    fontSize: 12,
    color: '#2A3962',
  },
});
